<template>
  <div class="c-app flex-row align-items-center">
    <CWrapper>
      <div class="c-body">
        <main class="c-main">
            <CContainer>
                <CRow class="justify-content-center">
                    <CCol md="8">
                            <CCard 
                                class="p-4"
                                text-color="dark"
                            >
                                <div class="card">
                                    <div class="card-header">                                       
                                       <dt>Download & Install <b>WE ARE 4 CHILD</b> App.</dt>
                                    </div>
                                    <div class="card-body">
                                        <p>
                                            Press the download button below to download the apk of the app, and follow the instructions to install. In case of any query, please email us at <code class="highlighter-rouge">info@strofes.com</code>
                                        </p>
                                        <div class="bd-example">
                                            <CButton color="primary" size="sm" href="https://play.google.com/store/apps/details?id=com.strofes.kslsa_survey">
                                                <CIcon name="cil-cloudDownload"/>&nbsp;Download APK
                                            </CButton>
                                        </div>
                                    </div>
                                </div>
                            </CCard>
                            
                    </CCol>
                </CRow>                
            </CContainer>
        </main>
      </div>
      <TheFooter/>
    </CWrapper>
  </div>
</template>

<script>

import TheFooter from '../../containers/TheFooter'
export default {
  name: 'Resources',
  components: {
    TheFooter
  },
  data() {
      return {
            

      }
  },
  methods: {
    
  }
}
</script>
